import { EventEmitter, Injectable, Output } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BlogsBaseModel } from "../../models/blogs/blogs-base.model";
import { ViewBlogModalComponent } from "src/app/shared/modals/view-blog-modal/view-blog-modal.component";

@Injectable({
  providedIn: 'root'
})
export class ViewBlogModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: BlogsBaseModel) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( ViewBlogModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xxl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    if(model){
        modalRef.componentInstance.model = model;
    }
    modalRef.result.then(() => {
        this.modelChanged.emit(true);
      });
  }
}